module.exports = __webpack_public_path__ + "img/icon_trade_eye_colse@3x.ef7b1def.png";